import { CustomerDeliveryDetails } from "./customer-delivery-details";
import { ProductDetail } from "./product-detail";


export class AssignedDeliveryDto {
    slot: string;
    transType: string;
    invNo: string;
    status: string;
    deliveryDate: string;
    locationName: string;
    assignedNo: string;
    serviceManCode: string;
    isApproved: string;
    noOfPackets: number;
    upiPaymentOnDeliveryTime: number;
}
export class OrderForDeliveryDto {
    invType: string;
    invoiceNo: string;
    invoiceDate: string;
    cashPaid: number;
    couponPaid: number;
    bankPaid: number;
    upiPaid: number;
    cardPaid: number;
    walletPaid: number;
    gatewayPaid: number;
    swipePaid: number;
    paytmPaid: number;
    deliveryCharge: number;
    customerCode: string;
    baseAmt: number;
    discAmt: number;
    taxableValue: number;
    cgstAmt: number;
    igstAmt: number;
    ugstAmt: number;
    sgstAmt: number;
    netAmt: number;
    referenceDocNo: string;
    deliveryAddressRefNo: number;
    productDetails: ProductDetail;
}
export class ProductOrderedDto {
    productCode: string;
    productName: string;
    price: number;
    qty: number;
    total: number;
    discAmt: number;
    taxableValue: number;
    cgstAmt: number;
    sgstAmt: number;
    ugstAmt: number;
    igstAmt: number;
    netAmt: number;
}
export class CustomerDto {
    refNo: string;
    customerName: string;
    constructorustomerMobile: string;
    customerEmail: string;
    stateCode: number;
    customerMobile:string;
}

export class AllDeliveryDetailsDto {
    assignedDeliveryDto: AssignedDeliveryDto;
    allOrdersForDeliveryDto: OrderForDeliveryDto;
    productOrderDto: ProductOrderedDto[];
    customerDto: CustomerDto;
    customerDeliveryDetails: CustomerDeliveryDetails;
    locationCode: number;
    locationName: string;
    noOfProducts: number;
    qty: number;
    companyCode: number;

    shippingStatus: string;
    seqNo: number = 0;

    fromLocCode: string;
    toLocCode: string;

}
